import { ICreateAuditoriaUseCase } from "../../../presentation/useCases/create/create_auditoria_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class CreateAuditoriaUseCase implements ICreateAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async createAuditoria(
    Evento: string | null,
    TipoAuditoria: number | null,
    EmAberto: boolean | null,
    DataElaboracao: Date | null,
    DataAuditoria: Date | null,
    DataTermino: Date | null,
    Criterio: string | null,
    Observacao: string | null,
    IdAuditor1: number | null,
    IdAuditor2: number | null,
    IdAuditor3: number | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
  ): Promise<number> {
    const response = await this.repository.createAuditoria(
      Evento,
      TipoAuditoria,
      EmAberto,
      DataElaboracao,
      DataAuditoria,
      DataTermino,
      Criterio,
      Observacao,
      IdAuditor1,
      IdAuditor2,
      IdAuditor3,
      Arquivo1,
      Arquivo2,
      nomeArquivo1,
      nomeArquivo2,
    );
    return response.idAuditoria;
  }
}
